// WP-STANDARD | OWNER TEST CONTEXT
// Status: REQUEST-SCOPED · SUPEROWNER-ONLY-BY-BACKEND · v1
// This value never changes the login/session. It only asks Owner endpoints to
// operate against another authorized Owner so superowner can test their exact data.
export const OWNER_CONTEXT_STORAGE_KEY = "webprofit.owner.contextUserId";
export const OWNER_CONTEXT_EVENT = "webprofit:owner-context-changed";

export function getOwnerContextUserId() {
  if (typeof window === "undefined") return "";
  return String(window.localStorage.getItem(OWNER_CONTEXT_STORAGE_KEY) || "").trim();
}

export function setOwnerContextUserId(userId = "") {
  if (typeof window === "undefined") return;
  const value = String(userId || "").trim();
  if (value) window.localStorage.setItem(OWNER_CONTEXT_STORAGE_KEY, value);
  else window.localStorage.removeItem(OWNER_CONTEXT_STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(OWNER_CONTEXT_EVENT, { detail: { userId: value } }));
}

export function clearOwnerContextUserId() {
  setOwnerContextUserId("");
}

export function ownerContextHeaders(path, headers = {}) {
  const normalizedPath = String(path || "");
  if (!/(^|\/)owner(?:\/|$)/.test(normalizedPath)) return headers;
  const contextUserId = getOwnerContextUserId();
  if (!contextUserId) return headers;
  return { ...headers, "X-WebProfit-Owner-Context": contextUserId };
}
